import { useTranslation } from "react-i18next";
import { Lead } from "../../../models/Lead";
import { ConfirmationModal } from "../../ConfirmationModal";
import { EnvelopeIcon, XMarkIcon } from "@heroicons/react/24/outline";

interface Props {
    info: {
        show: boolean;
        lead?: Lead;
    };
    onClose: () => void;
    sentMail: (lead: Lead) => void
}

export const SentLeadMailConfirmationModal: React.FC<Props> = ({
    info,
    onClose,
    sentMail
}) => {

    const { t } = useTranslation();

    const onSentMail = () => {
        sentMail(info.lead!)
        onClose();
    };

    return(
        <ConfirmationModal 
            label={t("SEND_MAIL")}
            isOpen={info.show}
            onClose={onClose}
            cancelButton={{ label: t("CLOSE"), icon: <XMarkIcon />, onClick: onClose, }}
            saveButton={{ label: t("SEND"), icon: <EnvelopeIcon />, onClick: onSentMail }}
        >
            <div className='w-full flex flex-wrap items-center justify-center'>
                <label className="text-lg font-semibold py-4 px-2 text-center">
                    {t('SEND_LEAD_MAIL_MESSAGE')}
                </label>
            </div>
        </ConfirmationModal>
    )
}